// Modules
import cn from 'classnames';

// Types
import type { TSidebarProps } from './Sidebar.type';

// Styles
import styles from './styles.module.scss';

// Components
import SidebarMenu from './SidebarMenu';

const Sidebar = (props: TSidebarProps) => {
  const {
    activeMainMenuClassName,
    activeMainMenuStyle,
    activeSubMenuClassName,
    activeSubMenuStyle,
    className,
    listMenu,
    mainMenuClassName,
    mainMenuStyle,
    mainMenuWrapperClassName,
    mainMenuWrapperStyle,
    subMenuClassName,
    subMenuStyle,
    subMenuWrapperClassName,
    subMenuWrapperStyle,
    ...restProps
  } = props;

  const sidebarCN = cn(styles.legion_sidebar, className);

  return (
    <nav className={sidebarCN} {...restProps}>
      {listMenu.map((item, index) => {
        return (
          <SidebarMenu
            key={index}
            menu={item}
            className={mainMenuWrapperClassName}
            style={mainMenuWrapperStyle}
            activeMainMenuClassName={activeMainMenuClassName}
            activeMainMenuStyle={activeMainMenuStyle}
            activeSubMenuClassName={activeSubMenuClassName}
            activeSubMenuStyle={activeSubMenuStyle}
            mainMenuClassName={mainMenuClassName}
            mainMenuStyle={mainMenuStyle}
            subMenuWrapperClassName={subMenuWrapperClassName}
            subMenuWrapperStyle={subMenuWrapperStyle}
            subMenuClassName={subMenuClassName}
            subMenuStyle={subMenuStyle}
          />
        );
      })}
    </nav>
  );
};

export default Sidebar;
